const loc = window.location;

export const IsAreaOfStudyActive = loc.host.endsWith('seasources.net');
